import React, { useState } from "react";
import useStyles from "../styles";
import config from "../../../config";

// components
import PageTitle from "../../../components/PageTitle/PageTitle";
import InputComponent from "../../partner/components/inputComponent";
import { CircularProgress } from "@material-ui/core";
import Modal from "../../modals/Modal";
import InputProfitProduct from "./inputProfitProduct";

export default function AddGroupTypePartner() {
    const expressions = {
        usuario: /^[a-zA-Z0-9_-]{4,16}$/, // Letras, numeros, guion y guion_bajo
        nombre: /^[a-zA-ZÀ-ÿ\s]{1,40}$/, // Letras y espacios, pueden llevar acentos.
        password: /^.{4,12}$/, // 4 a 12 digitos.
        email: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
        numbers: /^[0-9]*$/, // 7 a 14 numeros.
        texto: /^[a-zA-Z0-9 ]{1,500}$/, // Letras
        textNumberAndSymbols: /^[a-zA-ZÀ-ÿ\sS&%'#+-@"!¡¿?()0-9._]+$/i
    }

    const classes = useStyles();

    const [baseUrl, setBaseUrl] = useState(config.config[0].baseUrl);
    const [groupTypePartnerName, setGroupTypePartnerName] = useState({ text: '', valid: null });
    const [numberOfPersons, setNumberOfPersons] = useState({ text: '', valid: null });
    const [discount, setDiscount] = useState({ text: '', isDiscountByPercent: false, valid: null });

    const [isLoading, setIsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const closeModalLogin = e => {
        setShowModal(false);
    }

    const onSubmit = async e => {
        e.preventDefault();
        setIsLoading(true);

        if (groupTypePartnerName.valid === 'true' && numberOfPersons.valid === 'true') {

            const newGroupTypePartner = {
                name: groupTypePartnerName.text, numberOfPersons: numberOfPersons.text,
                discount: discount.text != null ? discount.text : '0.00', isDiscountByPercent: discount.isDiscountByPercent ? 1 : 0,
            };

            const response = await fetch(baseUrl + "createGroupTypePartner", {
                method: 'POST',
                headers: {
                    'Accept': 'application/json', 'Content-Type': 'application/json',
                    'Authorization': localStorage.getItem("token")
                },
                body: JSON.stringify(newGroupTypePartner)
            });

            const json = await response.json();
            if (json.message == "Ok") {
                setGroupTypePartnerName({ text: '', valid: null });
                setNumberOfPersons({ text: '', valid: null });
                setDiscount({ text: '', isDiscountByPercent: false, valid: null });
            } else {
                if (json.message == "Access is denied") {
                    setShowModal(true);
                }
            }

            setIsLoading(false);
        } else {
            setIsLoading(false);
        }
    }

    return (
        <div>
            {showModal ? (
                <Modal
                    isOpen={showModal}
                    closeModal={closeModalLogin}
                />
            ) : (
                <></>
            )}

            <PageTitle title="Configuración" />

            <div className={classes.divAddPage} >
                <div className={classes.divTitle}>
                    <label className={classes.titleStyle}>Agregar grupo de membrecía</label>
                </div>

                <div className={classes.divColumn} >
                    <InputComponent
                        text={groupTypePartnerName}
                        setPartnerCode={setGroupTypePartnerName}
                        type="text"
                        label="Nombre"
                        name="name"
                        regularExpression={expressions.textNumberAndSymbols}
                        placeholder="Nombre"
                    />

                    <InputComponent
                        text={numberOfPersons}
                        setPartnerCode={setNumberOfPersons}
                        type="text"
                        label="Mínimo de personas"
                        name="numberOfPersons"
                        regularExpression={expressions.numbers}
                        placeholder="0"
                    />

                    <InputProfitProduct
                        text={discount}
                        setPartnerCode={setDiscount}
                        type="text"
                        label="Descuento"
                        name="discount"
                        placeholder="0.00"
                    />
                </div>

                <div className={classes.divButton}>
                    {isLoading ? (
                        <CircularProgress size={26} className={classes.loginLoader} />
                    ) : (
                        <button
                            className={groupTypePartnerName.valid === 'true' && numberOfPersons.valid === 'true' ?
                                classes.enableButton : classes.disableButton}
                            onClick={onSubmit}
                        >Agregar</button>
                    )}
                </div>
            </div>
        </div>
    );
}
